<mat-sidenav-container>
    <mat-sidenav #sidenav [mode]="'over'">
      <app-sidenav-content></app-sidenav-content>
    </mat-sidenav>  
    <mat-sidenav-content>
      <app-header
        (onboardingIcon)="startTour()"  
        (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
        (openSideNav)="sidenav.toggle()">
      </app-header>
      <div class="container not-found">
        <h1 class="h_404">{{ "page_could_not_found" | translate }}</h1>
        <p class="p_404">
          {{ "dont_stop_exploring_ggs" | translate }}
          <br/>
          {{ "continue_search_bar" | translate }}
        </p>        
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        
        <div class="search-field-wrapper">
          <mat-form-field class="w-100 mb-5" appearance="outline">
            <mat-label>{{"search_placeholder" | translate }}</mat-label>
            <input
              #searchInput
              (focus)="goToSearch()"
              matInput
              placeholder="{{'search_placeholder' | translate }}..."
            />
          </mat-form-field>        
        </div>
        
        <!--recent releases start-->
        <div class="featured-wrapper">
          <div class="featured-heading" [class.is-mobile]="isHandsetPortrait">
            <div class="main-heading-left">{{ "explore_latest_releases" | translate }}</div>
          </div>
          <div *ngIf="isHandsetPortrait"
                class="dashboard-posts-carousel-wrapper">
            <owl-carousel-o
              [options]="customOptions"
              (translated)="getPassedData($event)"
              (initialized)="getPassedData($event)"
              #recentCarousel
            >
              <ng-container *ngIf="recentReleases.length">
                <ng-container *ngFor="let recentPost of recentReleases">
                  <ng-template
                    carouselSlide
                    [id]="parseAsString(recentPost.BaniId)"
                  >
                    <div
                      (click)="goToPost(recentPost.BaniCode)"
                      style="
                        background-image: url('{{ fetchImageThumbnail(recentPost) }}');
                      "
                      class="carousel-text-wrapper is-mobile"
                    ></div>
                    <div
                      (click)="goToPost(recentPost.BaniCode)"
                      class="mobile-carousel-text-wrapper"
                    >
                      <div class="carousel-heading">
                        {{
                          recentPost?.BaniName?.trim()
                            ? recentPost.BaniName
                            : "In Progress"
                        }}
                      </div>
                      <div class="carousel-sub-heading">
                        {{
                          recentPost?.Introduction?.trim()
                            ? showSmallerString(recentPost.Introduction)
                            : "Coming_Soon" | translate 
                        }}
                        <span 
                          class="view-more-link"
                        >
                          <a class="view-more-link" href="/bani/{{recentPost.BaniCode}}">{{ "more" | translate }}...</a>
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </ng-container>
              </ng-container>
            </owl-carousel-o>
            <div class="featured-carousel-nav">
              <div
                class="carousel-nav-control"
                (click)="recentCarousel.prev()">
                <span> &#8249; </span>
              </div>
              <div
                class="carousel-nav-control"
                (click)="recentCarousel.next()">
                &#8250;
              </div>
            </div>
          </div>
          <div class="desktop">
            <ng-container *ngIf="isRecentPostsLoading">
              <mat-grid-list
                *ngIf="!isHandsetPortrait"
                cols="3"
                rowHeight="350px"
                gutterSize="5px" >
                <mat-grid-tile *ngFor="let loading of [0, 1, 2]">
                  <div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div class="featured-video-thumbnail animate"></div>
                    </div>
                    <div class="featured-video-description">
                      <div class="featured-video-heading">
                        <div class="loading-heading animate"></div>
                      </div>
                      <div class="featured-video-sub-heading">
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                      </div>
                    </div>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </ng-container>
            <ng-container *ngIf="!isRecentPostsLoading">
              <mat-grid-list
                *ngIf="!isHandsetPortrait"
                cols="3"
                rowHeight="350px"
                gutterSize="20px">
                <mat-grid-tile *ngFor="let recentPost of recentReleases">
                  <div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div 
                      class="featured-video-thumbnail youtub-thumb" 
                      style="background-image: url('{{ fetchImageThumbnail(recentPost) }}');" 
                      (click)="openVideoPopup(recentPost)">
                        <div *ngIf="recentPost.BaniVideoURL" class="video-thumbnail-cover">
                          <img alt="Play Button Image" src="/assets/images/play.webp" />
                        </div>
                      </div>
                    </div>
                    <a class="view-more-div" href="/bani/{{recentPost.BaniCode}}">
                    <div (click)="goToPost(recentPost.BaniCode)" class="featured-video-description">
                      <div class="featured-video-heading">
                        {{ recentPost.BaniName }}
                      </div>
                      <div class="featured-video-sub-heading">
                        {{
                          recentPost?.Introduction?.trim()
                            ? showSmallerString(recentPost.Introduction)
                            : "Coming_Soon" | translate 
                        }}
                        <span class="view-more-link">
                          {{ "more" | translate }}...
                        </span>
                      </div>
                    </div>
                    </a>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </ng-container>
          </div>
          <div class="mt-4" style="text-align: right;">
            <button
              class="sggs-primary-button"
              mat-stroked-button
              color="primary"
              *ngIf="!isHandsetPortrait"
              (click)="goToSearch()">
              {{ "View More" | translate }}
            </button>
          </div>
        </div>
        <!--recent releases stop-->  

        <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
      </div>
    </mat-sidenav-content>
</mat-sidenav-container>